import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    roleSelectData;
    currVal;
    isDisabled;
    currIndex = '';
    defaultExpandKey = [];
    value1 = [];
    handleCheckChange(data) {
        console.log('data:', data);
        this.$emit('onCheckedNode', this.value1);
        // this.getCheckedKeys();
    }
    onOpenChange() {
        this.value1 = this.currVal;
    }
};
__decorate([
    Prop()
], default_1.prototype, "roleSelectData", void 0);
__decorate([
    Prop()
], default_1.prototype, "currVal", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "isDisabled", void 0);
__decorate([
    Watch('currVal')
], default_1.prototype, "onOpenChange", null);
default_1 = __decorate([
    Component({
        name: 'RoleTree',
        i18n: {
            messages: {
                'en-us': {},
                zh: {},
            },
        },
    })
], default_1);
export default default_1;
